import * as S from "./MoreNavigation.styles";
import * as T from "../../atoms/MoreNavItem/MoreNavItem.styles";
import { navMenu } from "../../../data/MoreDummy";
import { MoreNavItem } from "../../atoms/MoreNavItem";
import { ReactComponent as IconMenu08 } from "../../../styles/assets/svg/icon-more-ver.svg";
import { ReactComponent as IconMenu10 } from "../../../styles/assets/svg/icon-logoutDoor-black.svg";
import React from "react";

type MoreNavigationType = {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const MoreNavigation = ({ setIsModal }: MoreNavigationType) => {
  return (
    <S.BottomNav>
      <S.BottomNavList>
        {navMenu.map((item: any, idx: number) => {
          return (
            <MoreNavItem
              icon={idx}
              menuTitle={item.menuTitle}
              url={item.url}
              key={idx}
            />
          );
        })}
        <T.NavItemLayout onClick={() => setIsModal(true)}>
          <T.NavItemBox>
            <T.NavItemIcon>
              <IconMenu10 />
            </T.NavItemIcon>
            <T.NavItemTit>로그아웃</T.NavItemTit>
          </T.NavItemBox>
        </T.NavItemLayout>
        <T.NavItemLayout>
          <T.NavItemBox>
            <T.NavItemIcon>
              <IconMenu08 />
            </T.NavItemIcon>
            <T.NavItemTit> 버전정보 </T.NavItemTit>
          </T.NavItemBox>
          <T.NavItemTit> 1.9.26 </T.NavItemTit>
        </T.NavItemLayout>
      </S.BottomNavList>
    </S.BottomNav>
  );
};
